import { render, staticRenderFns } from "./BannerDetails.vue?vue&type=template&id=cc25ea58&scoped=true"
import script from "./BannerDetails.vue?vue&type=script&lang=js"
export * from "./BannerDetails.vue?vue&type=script&lang=js"
import style0 from "./BannerDetails.vue?vue&type=style&index=0&id=cc25ea58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc25ea58",
  null
  
)

export default component.exports